<ng-container *ngIf="!errorType">
  <div *ngIf="!loaded" class="loader">
    <loader-overlay
      [darkOnly]="previewMode === 'popup'"
      [styles]="{ backgroundColor: 'transparent', backdropFilter: 'none' }"
    >
    </loader-overlay>
  </div>
  <pre
    #txtRef
    [ngClass]="{ 'hide-text-preview': !srcUrl }"
    [attr.is-popup]="previewMode === 'popup'"
    class="text-preview"
    [style]="{ fontSize: fontSize + 'px' }"
    [class.popup-header-text]="previewMode === 'popup'"
    [innerHTML]="model?.fileType?.includes('html') ? (srcUrl | safe: 'html') : ''"
  ></pre>
</ng-container>

<ng-container *ngIf="errorType">
  <error-preview
    [errorType]="errorType"
    [previewMode]="previewMode"
    [icon]="model.icon"
    (reload)="reload.emit()"
    (download)="download.emit()"
    (open)="open.emit()"
  >
  </error-preview>
</ng-container>
